import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { GAS_LIMIT } from '../utils/constants.js';

const shortValidatorLink = function (cell, formatterParams, onRendered) {
    const address = cell.getValue();
    var rowData = cell.getRow().getData();
    var label = address;
    if (rowData.validator === undefined || rowData.validator === "") {
        if (label.length >= 10) {
            var firstFive = address.slice(0, 5);
            var lastFive = address.slice(-5);
            label = firstFive + "..." + lastFive;
        }
    } else {
        label = rowData.validator
    }
    const link = `https://etherscan.io/address/${address}`;

    return `<a href="${link}" target="_blank">${label}</a>`;
};

const relayName = function (relayURL) {
    switch (relayURL) {
        case "https://agnostic-relay.net":
            return "Agnostic"
        case "https://bloxroute.ethical.blxrbdn.com":
            return "BloXroute Ethical"
        case "https://bloxroute.max-profit.blxrbdn.com":
            return "BloXroute MaxProfit"
        case "https://bloxroute.regulated.blxrbdn.com":
            return "BloXroute Regulated"
        case "https://relay.edennetwork.io":
            return "Eden"
        case "https://boost-relay.flashbots.net":
            return "Flashbots"
        case "https://builder-relay-mainnet.blocknative.com":
            return "Blocknative"
        case "https://mainnet.aestus.live":
            return "Aestus"
        case "https://relay.ultrasound.money":
            return "Ultrasound"
        case "https://mainnet-relay.securerpc.com":
            return "Manifold"
        default:
            return "Unknown"
    }
};

const formatRelayMap = function (cell, formatterParams, onRendered) {
    var relayList = [];
    for (const [key, value] of Object.entries(cell.getValue())) {
        relayList.push({ url: key, name: relayName(key) });
    }
    if (relayList.length > 0) {
        relayList.sort((a, b) => a.name.localeCompare(b.name));
        const relayAnchors = relayList
            .map((relay) => `<a href="${relay.url}" target="_blank">${relay.name}</a>`)
            .join(", ");
        return relayAnchors;
    }
    return "-";
};

const boldFormatter = function (cell, formatterParams, onRendered) {
    return `<strong>${cell.getValue()}</strong>`;
};

export default class BlockNextUI {

    constructor(element) {
        this.padding = { top: 20, right: 20, bottom: 20, left: 20 };
        var parentDiv = document.querySelector(element); // Replace with the ID of your parent div
        var rect = parentDiv.getBoundingClientRect();
        this.height = rect.height;
        this.width = rect.width;

        this.table = new Tabulator(element, {
            layout: "fitColumns",
            height: this.height,
            responsiveLayout: "hide",
            maxHeight: "100%",
            rowFormatter: function (row) {
                row.getElement().style.height = "24px";
                row.getElement().style.backgroundColor = "#202124";
            },
            cellFormatter: function (cell) {
                cell.getElement().style.height = "24px";
            },
            columns: [
                { title: "Builder", field: "builder", sorter: "string", headerSort: false, hozAlign: "left", width: "160" },
                { title: "Validator", field: "fee_recipient", sorter: "string", headerSort: false, hozAlign: "left", width: "160", formatter: shortValidatorLink },
                { title: "Relays", field: "relays", sorter: "string", headerSort: false, hozAlign: "left", formatter: formatRelayMap },
                { title: "Gas", field: "gas", sorter: "string", headerSort: false, hozAlign: "left", width: "60" },
                { title: "Value", field: "value", sorter: "string", headerSort: false, hozAlign: "left", width: "100", formatter: boldFormatter },
            ],
        });

        this.table.on("tableBuilt", () => {
            this.table.setData([{ "builder": "-", "gas": "-", "fee_recipient": "-", "relays": {}, "value": "-" }]);
            this.ready = true
        });

        // vars
        this.lastBlock = 0
    }

    newBlockSummary = (block_summary) => {
        this.lastBlock = block_summary.block
        this.setNextBlockNumber(block_summary.block + 1)
        // TODO: reset row data
        if (this.ready) {
            this.table.setData([{ "builder": "-", "gas": "-", "fee_recipient": "-", "relays": {}, "value": "-" }]);
        }
    }

    newBidSummary = (bid_summary) => {
        const rows = this.table.getRows();
        const processedSummary = this.processBidSummary(bid_summary);

        if (this.ready && bid_summary.block > this.lastBlock) {
            this.setNextBlockNumber(bid_summary.block)
            if (rows.length > 0) {
                const firstRow = rows[0];
                firstRow.update({ ...firstRow.getData(), ...processedSummary });
            } else {
                this.table.addRow(processedSummary);
            }
        }
    }

    setNextBlockNumber = (block_number) => {
        const next_block_number = document.querySelector('#next_block_number'); // Replace 'h3' with the appropriate selector for your element
        if (next_block_number) {
            next_block_number.textContent = "- " + block_number;
        }
    }

    processBidSummary = (bid_summary) => {
        // process block_summary
        bid_summary.builder = bid_summary.best.builder
        bid_summary.value = (bid_summary.best.value).toFixed(8)
        bid_summary.gas = (bid_summary.best.gas_used / GAS_LIMIT * 100).toFixed(2) + "%"

        return bid_summary
    }

}
